export const COMMUNITY = '/v4/installer/community/?limit=5000';
